import React, {useEffect, useCallback} from 'react'
import { NavLink } from "react-router-dom";
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid';

import confirmModalStyles from '../styles/components/confirmModal.module.scss';
import { X } from 'react-feather';
import Button from './Button';

const ConfirmationModal = ({ title, label, confirmText, cancelText, onConfirm, onClose, secondLabel, isOnlyButton, goToSettings, isEmailNoMatch }) => {
    const escFunction = useCallback((event) => {
        if(event.keyCode === 27) {
            onClose();
        }
    }, [onClose]);

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);

        return () => {
          document.removeEventListener("keydown", escFunction, false);
        };
      }, [escFunction]);
    return (
        <section className={[confirmModalStyles.alertPrompt__background, confirmModalStyles.__active].join(' ')}>
            <section className={confirmModalStyles.alertPrompt__card}>
                <header className={confirmModalStyles.alertPrompt__header}>
                    <Row start="xs" between="xs" middle="xs">
                        <Col xs={11}>
                            <h4>
                                {title}
                            </h4>
                        </Col>
                        <Col xs={1}>
                            <span className={confirmModalStyles.alertPrompt__close} onClick={onClose}>
                                <X size={24} color="#C61C33"/>
                            </span>
                        </Col>
                    </Row>
                </header>
                <section className={confirmModalStyles.alertPrompt__form}>
                    <Row center="xs">
                        <Col xs={12} className={confirmModalStyles.alertPrompt__content}>
                            <p>{label}</p>
                            <p> <br/> {secondLabel}</p>
                        </Col>
                        { !isOnlyButton ? 
                        ( <>
                        <Col xs={4}>
                            <Button
                                label={cancelText}
                                cancel={true}
                                click={onClose}
                            />
                        </Col>
                        <Col xs={4}>
                            { !goToSettings &&
                                <Button
                                    login={true}
                                    label={confirmText}
                                    click={onConfirm}
                                />
                            }
                            { goToSettings &&
                                <NavLink to="/settings">
                                    <Button
                                        login={true}
                                        label={confirmText}
                                    />
                                </NavLink>
                            }
                        </Col> </>) : 
                        (
                        <Col xs={4}>
                            <Button
                                login={true}
                                label={confirmText}
                                click={onClose}
                            />
                        </Col>
                        )
                        }
                    </Row>
                </section>
            </section>
        </section>
    )
}

ConfirmationModal.propTypes = {
    title: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    confirmText: PropTypes.string.isRequired,
    cancelText: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired

}

export default ConfirmationModal

